import React, { useState } from 'react';  // Import React and useState hook
import 'bootstrap/dist/css/bootstrap.min.css';  // Import Bootstrap styles
import { GrStatusGood } from "react-icons/gr";  // Import GrStatusGood icon

function Pickup() {
  // State variables to store form data
  const [date, setDate] = useState('');  // Date of pickup
  const [time, setTime] = useState('');  // Time of package readiness
  const [shipper, setShipper] = useState('');  // Shipper selection
  const [numPackages, setNumPackages] = useState(1);  // Number of packages to be picked up

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevents default form submission behavior

    // Log form data to console (for demonstration purposes)
    

    // Reset form fields after submission
    setDate('');
    setTime('');
    setShipper('');
    setNumPackages(1);
  };

  return (
    <div style={{ width: '95%', margin: '0 auto', padding: "20px" }}>
      <div className="row justify-content-start">
        <div className="col-md-6" style={{ border: '1px solid #ccc', padding: '20px', borderTop: '3px solid #004aad', borderRadius: '5px', marginLeft: "10px", backgroundColor: "#f4f4f4" }}>
          <h2 className="mb-4">Pickup Details</h2>
          
          {/* Form for submitting pickup details */}
          <form onSubmit={handleSubmit} className="needs-validation" noValidate>
            {/* Date input field */}
            <div className="mb-3">
              <label htmlFor="date" className="form-label">Date:</label>
              <input
                type="date"
                id="date"
                className="form-control"
                value={date}
                onChange={(e) => setDate(e.target.value)}  // Update date state when the user selects a date
                required
              />
              <div className="invalid-feedback">Please select a date.</div>  {/* Error message if date is not selected */}
            </div>

            {/* Time input field for package readiness */}
            <div className="mb-3">
              <label htmlFor="time" className="form-label">Package Ready Time:</label>
              <input
                type="time"
                id="time"
                className="form-control"
                value={time}
                onChange={(e) => setTime(e.target.value)}  // Update time state when the user selects a time
                required
              />
              <div className="invalid-feedback">Please select a time.</div>  {/* Error message if time is not selected */}
            </div>

            {/* Select dropdown for shipper */}
            <div className="mb-3">
              <label htmlFor="shipper" className="form-label">Shipper:</label>
              <select
                id="shipper"
                className="form-select"
                value={shipper}
                onChange={(e) => setShipper(e.target.value)}  // Update shipper state when a shipper is selected
                required
              >
                <option value="" disabled>Select a shipper</option>  {/* Placeholder option */}
                <option value="UPS COURIER">UPS COURIER</option>  {/* Static shipper option */}
                {/* Add other shipper options dynamically if needed */}
              </select>
              <div className="invalid-feedback">Please select a shipper.</div>  {/* Error message if no shipper is selected */}
            </div>

            {/* Number of packages input field */}
            <div className="mb-3">
              <label htmlFor="numPackages" className="form-label">Number of Packages:</label>
              <input
                type="number"
                id="numPackages"
                className="form-control"
                value={numPackages}
                onChange={(e) => setNumPackages(parseInt(e.target.value))}  // Update number of packages state when the user inputs a value
                min="1"  // Ensure the minimum value is 1
                required
              />
              <div className="invalid-feedback">Please enter the number of packages.</div>  {/* Error message if number of packages is not entered */}
            </div>

            {/* Submit button */}
            <button
              type="submit"
              className="btn btn-primary"
              style={{ backgroundColor: "#004aad" }}
            >
              <GrStatusGood style={{ fontSize: "20px" }} /> Submit  {/* Submit button with icon */}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Pickup;